export default "__VITE_ASSET__b3044393__"